import React from 'react'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { LoginPage } from './pages/LoginPage'
import { DashboardPage } from './pages/DashboardPage'
import { DevicesPage } from './pages/DevicesPage'
import './App.css'

// API Configuration
const API_BASE_URL = 'https://gemini-billing-backend.krapphead.workers.dev'

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
})

interface User {
  id: string
  username: string
  role: string
}

function App() {
  const [isAuthenticated, setIsAuthenticated] = React.useState(false)
  const [currentPage, setCurrentPage] = React.useState('login')
  const [user, setUser] = React.useState<User | null>(null)

  const handleLogin = async (username: string, password: string) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json() as { success: boolean; user?: User; error?: string }

      if (data.success) {
        setUser(data.user || null)
        setIsAuthenticated(true)
        setCurrentPage('dashboard')
      } else {
        alert('Login failed: ' + (data.error || 'Unknown error'))
      }
    } catch (error) {
      console.error('Login error:', error)
      alert('Login failed. Please try again.')
    }
  }

  const handleLogout = async () => {
    try {
      await fetch(`${API_BASE_URL}/api/auth/logout`, {
        method: 'POST',
      })
      setIsAuthenticated(false)
      setUser(null)
      setCurrentPage('login')
    } catch (error) {
      console.error('Logout error:', error)
    }
  }

  const renderPage = () => {
    if (!isAuthenticated) {
      return <LoginPage onLogin={handleLogin} />
    }

    switch (currentPage) {
      case 'dashboard':
        return (
          <DashboardPage
            user={user}
            onLogout={handleLogout}
            onNavigate={(page: string) => setCurrentPage(page)}
          />
        )
      case 'devices':
        return (
          <DevicesPage
            user={user}
            onLogout={handleLogout}
            onNavigate={(page: string) => setCurrentPage(page)}
          />
        )
      default:
        return <LoginPage onLogin={handleLogin} />
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className="App">
        {renderPage()}
      </div>
    </ThemeProvider>
  )
}

export default App 